/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=d015ba80"
const script = {}

import exportComponent from "../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__